<template>
  <div class="header-wrap">
    <div class="left-view">
      <div class="portrait">
        <img
          src="@/assets/image/schoolLogo.png"
          alt=""
          width="100%"
          height="100%"
        />
      </div>
      <router-link to="/home">
        <div class="project-name">
          <span class="zh">
            电商选品虚拟仿真实验
          </span>
          <span class="en">
            Virtual simulation experiment of tea industry e-commerce selection
            for Southeast Asia
          </span>
        </div>
      </router-link>
    </div>
    <div class="right-view">
      <el-dropdown @command="layout">
        <div class="el-dropdown-link">
          <svg
            t="1625811667112"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2406"
            width="200"
            height="200"
          >
            <path
              d="M512.01 1022.082C229.676 1022.082 0.79 793.283 0.79 511.046 0.79 228.8 229.676 0 512.01 0c282.314 0 511.2 228.799 511.2 511.046-0.002 282.24-228.887 511.036-511.2 511.036z m0-926.256c-229.385 0-415.37 185.885-415.37 415.221 0 107.227 41.02 204.655 107.802 278.34 60.14-29.093 38.063-4.885 116.772-37.275 80.54-33.09 99.611-44.64 99.611-44.64l0.777-76.295s-30.17-22.89-39.544-94.683c-18.895 5.426-25.109-21.989-26.238-39.43-1.001-16.862-10.926-69.487 12.106-64.739-4.714-35.144-8.094-66.844-6.417-83.633 5.763-58.939 62.973-120.52 151.105-125.018 103.666 4.486 144.738 66.03 150.501 124.968 1.68 16.801-2.028 48.512-6.74 83.595 23.026-4.686 13.03 47.861 11.902 64.727-1.029 17.44-7.395 44.756-26.21 39.342-9.42 71.79-39.593 94.498-39.593 94.498l0.726 75.924s19.07 10.789 99.61 43.893c78.708 32.387 56.604 9.61 116.775 38.766 66.752-73.687 107.772-171.102 107.772-278.34 0-229.335-185.959-415.22-415.346-415.22z"
              p-id="2407"
            ></path>
          </svg>
          <i style="color: white" class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerCom",
  methods: {
    layout() {
      this.$axios.get("/login/logout").then((res) => {
        if (res.succeed) {
          this.$router.push("/");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header-wrap {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

div.left-view {
  display: flex;
  align-items: center;

  .portrait {
    width: 42px;
    height: 42px;
    background: #ffffff;
    border-radius: 50%;
    opacity: 1;
    margin-right: 26px;
  }

  .project-name {
    display: flex;
    flex-direction: column;

    span.zh {
      height: 19px;
      font-size: 15px;
      font-weight: bold;
      color: #ffffff;
      opacity: 1;
    }

    span.en {
      height: 9px;
      font-size: 7px;
      font-weight: 400;
      color: #ffffff;
      opacity: 1;
    }
  }
}

div.right-view {
  .el-dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  svg {
    width: 30px;
    height: 30px;
    fill: white;
  }
}
</style>
